module.exports = __webpack_public_path__ + "static/img/superiority_pic1.b99752d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/superiority_pic1.png
// module id = C9uL
// module chunks = 1